// Pikko paw-in-heart logo (inline SVG)
export default function PikkoLogo({ className = "", size = 40, color = "#EF6F2C" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      fill="none"
      aria-label="Pikko Pet Care logo"
    >
      {/* Heart background */}
      <path
        d="M32 56s-22-12.4-22-28.2C10 19 16.6 13 24 13c4.5 0 7.4 2 8 2.7C32.6 15 35.5 13 40 13c7.4 0 14 6 14 14.8C54 43.6 32 56 32 56Z"
        fill={color}
      />
      {/* Paw inside */}
      <g fill="#FFFFFF">
        <ellipse cx="22" cy="26" rx="3" ry="3.6" />
        <ellipse cx="42" cy="26" rx="3" ry="3.6" />
        <ellipse cx="16" cy="33.2" rx="2.6" ry="3" />
        <ellipse cx="48" cy="33.2" rx="2.6" ry="3" />
        <path d="M32 31.5c5 0 9 4.2 9 8.5 0 3.6-3 5.5-6 5.5-1.5 0-2.5-.5-3-.8-.5.3-1.5.8-3 .8-3 0-6-1.9-6-5.5 0-4.3 4-8.5 9-8.5Z" />
      </g>
    </svg>
  );
}
